module.exports = __webpack_public_path__ + "bfc35b23adf7f61c83cc9052b9f93e50.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_2-768.webp.png
// module id = 583
// module chunks = 0